module.exports = __webpack_public_path__ + "img/东洲估价@2x.c0b2c2b7.png";